import { TEMPLATES } from "constants/routes";
import { serviceRoles } from "config/access";
import { checkAccess } from "helpers/auth";
import TemplatePage from "./container/TemplatePage";

export default function getSettingsRoute(userAuth) {
  const { account } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: TEMPLATES,
    withSidebar: true,
    withAppBar: true,
    component: TemplatePage,
  };
}
